import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {AuthProvider} from './contexts/auth';
import AppRoutes from './routes/routes';
import { AlertaProvider } from './contexts/alerta';
import Alert from './components/alerta';

export default function App() {
  return (
    <AuthProvider>
      <AlertaProvider>
        <Alert />
        <AppRoutes/>
      </AlertaProvider>
    </AuthProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
